import { general_states } from "../../utils/staticEnums";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const STOCK_BASE = "/orders";
const buildUrl = (endpoint) => STOCK_BASE + endpoint;

const ordersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOrders: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Orders' }],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        getOrdersSelect: builder.query({
            query: filterData => ({
                url: buildUrl(`?page=1&size=25`),
                method: 'POST',
                body: filterData,
            }),
            providesTags: () => [{ type: 'OrdersSelect' }],
        }),
        getPausedOrdersForProcessing: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: {
                    state: [general_states.TO_PROCESS],
                },
            }),
            providesTags: () => [{ type: 'OrdersForProcessing' }],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        getOrder: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
                meta: { customContentType: true }, 
            }),
            providesTags: () => [{ type: 'OrdersSingle' }],
        }),
        createOrder: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: orderInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Orders'}, { type: 'OrderLines' }, { type: 'OrderTotals' }],
        }),
        editOrderCarrier: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.orderId}/suggestedcarrier`),
                method: 'PUT',
                body: orderInfo,
            }),

        }),
        duplicateOrder: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.id}/duplicate`),
                method: 'POST',
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrdersSingle' }, {type: 'Orders'}, { type: 'OrderLines' }, { type: `LogsOrder`, id: arg.id }],
        }),
        updateOrder: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.id}`),
                method: 'PUT',
                body: orderInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrdersSingle' }, {type: 'Orders'}, { type: 'OrderLines' }, { type: `LogsOrder`, id: arg.id },{ type: "OrdersWithoutCosts" }, { type: 'OrderTotals' }, { type: 'Shipments' }, { type: 'NoCostsCount' }],
        }),
        getOrderPickingList: builder.query({
            query: body => ({
                url: buildUrl(`/pickinglines`),
                method: 'POST',
                body: body,
                meta: { customContentType: true }, 
            }),
            invalidatesTags: [`OrderPickingList`],
        }),
        updateOrderPickingLine: builder.mutation({
            query: pickingLineInfo => ({
                url: buildUrl(`/${pickingLineInfo.orderId}/pickinglines/${pickingLineInfo.id}`),
                method: 'PUT',
                body: pickingLineInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrderPickingLines' }],
        }),
        getOrderPickingListPDF: builder.mutation({
            query: body => ({
                url: buildUrl(`/pickinglines?type=pdf`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    // const blob = await response.blob();
                    const blob = new Blob([await response.blob()], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    return {data: url};
                },
            }),
        }),
        getOrderPickingSlipPDF: builder.mutation({
            query: body => ({
                url: buildUrl(`/${body.orderId}/pickingslip`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    // const blob = await response.blob();
                    const blob = new Blob([await response.blob()], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    return {data: url};
                },
            }),
        }),
        replaceShipment: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/shipment/${body.id}/resend`),
                method: 'POST',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrdersSingle' }, { type: `LogsOrder`, id: arg.id }],
            //providesTags: (result, error, body) => [{ type: `${body.order.id}Single` }]
        }),
        cancelShipment: builder.mutation({
            query: id => ({
                url: buildUrl(`/shipment/${id}/cancel`),
                method: 'PUT',
            }),
            //providesTags: (result, error, body) => [{ type: `${body.order.id}Single` }]
        }),
        activateShipment: builder.mutation({
            query: ({ shipmentId, workspaceId }) => ({
                url: `/shipments/${shipmentId}/activate`,
                method: 'POST',
                body: { workspaceId },
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrderShipments' }, { type: 'OrdersSingle' }],
        }),
        getOrderPickingLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/pickinglines`),
                method: 'POST',
                body: args.body,
                meta: { customContentType: true }, 
            }),
            providesTags: () => [{ type: 'OrderPickingLines' }],
        }),
        getOrderStatusCounts: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/orderstatuscounts?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'OrdersStatusCounts' }], 
            onQueryStarted: muiDataGridStarted.bind(null, 'getOrdersStatusCounts', 'OrdersStatusCounts')
        }),
        getDashboardOrderStatusCounts: builder.query({
            query: () => ({
                url: buildUrl(`/orderstatuscounts/dashboard`),
                method: 'GET',
                meta: { customContentType: true }, 
            }),
            providesTags: () => [{ type: 'OrdersStatusCountsDashboard' }], 
            //onQueryStarted: muiDataGridStarted.bind(null, 'getDashboardOrdersStatusCounts', 'DashboardOrdersStatusCounts')
        }),
        getOrderCompareCountsDashboard: builder.query({
            query: () => ({
                url: buildUrl(`/ordercomparecountsdashboard`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'getOrderCompareCountsDashboard' }], 
            //onQueryStarted: muiDataGridStarted.bind(null, 'getDashboardOrdersStatusCounts', 'DashboardOrdersStatusCounts')
        }),
        getOrderLines: builder.query({

            // query: ({ args, invalidate }) => {
            //     console.log("QUERY() CALLED WITH:", { args, invalidate });

            //     const url = buildUrl(`/${args.id}/orderlines?page=${args.page}&size=${args.size}`);
            //     console.log("BUILT URL:", url);

            //     return {
            //         url,
            //         method: 'POST',
            //         body: args.body,
            //     };
            // },
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/orderlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'OrderLines' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getOrderLines', 'OrderLines')
        }),
        getAllOrderLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/orderlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'OrderLines' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getAllOrderLines', 'OrderLines')
        }),
        getOrderReplenishLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/replenishlines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'ReplenishLines' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getOrderReplenishLines', 'ReplenishLines')
        }),
        getOrderColli: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/colli?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'OrderColli' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getOrderColli', 'OrderColli')
        }),
        getOrderMutations: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/mutations?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'OrderMutations' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getOrderMutations', 'OrderMutations')
        }),
        splitOrder: builder.mutation({
            query: info => ({
                url: buildUrl(`/${info.id}/split`),
                method: 'POST',
                body: {products:info.products},
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrderPickingLines' }, {type: 'OrderLines'}, {type: 'Orders'}, {type: 'OrdersSingle'}],
        }),
        updateOrderLines: builder.mutation({
            query: orderLineInfo => ({
                url: buildUrl(`/${orderLineInfo.orderId}/orderlines/update`),
                method: 'POST',
                body: orderLineInfo.body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrderLines'}, {type: 'Orders'}, { type: 'OrdersSingle' }, { type: 'LogsSingle' }],
        }),
        updatePickupOrder: builder.mutation({
            query: pickupInfo => ({
                url: buildUrl(`/${pickupInfo.id}/pickup`),
                method: 'PUT',
                body: pickupInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Orders'}, {type: 'OrdersSingle'}],
        }),
        updatePriority: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.id}/priority`),
                method: 'PUT',
                body: orderInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Orders'}, {type: 'OrdersSingle'}, { type: 'OrderLines' }],
        }),
        getOrderEvents: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/events`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'OrderEvents', id }],
        }),
        createOrderEvent: builder.mutation({
            query: eventInfo => ({
                url: buildUrl(`/${eventInfo.id}/events`),
                method: 'POST',
                body: { message: eventInfo.message },
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrderEvents', id: arg.id }, { type: 'LogsSingle' }],
        }),
        updateOrderEvent: builder.mutation({
            query: eventInfo => ({
                url: buildUrl(`/${eventInfo.id}/events/${eventInfo.eventId}`),
                method: 'PUT',
                body: { message: eventInfo.message },
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrderEvents', id: arg.id }, { type: 'LogsSingle' }],
        }),
        deleteOrderEvent: builder.mutation({
            query: eventInfo => ({
                url: buildUrl(`/${eventInfo.id}/events/${eventInfo.eventId}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'OrderEvents', id: arg.id }, { type: 'LogsSingle' }],
        }),
        updateOrderFields: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.id}/fields`),
                method: 'PUT',
                body: orderInfo.body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Orders'}, {type: 'OrdersSingle'}, { type: `LogsOrder`, id: arg.id }],
        }),
        updateOrderPickingType: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.id}/pickingtype`),
                method: 'PUT',
                body: orderInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Orders'}, {type: 'OrdersSingle'}, { type: 'OrderLines' }],
        }),
        resyncOrder: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/${orderInfo.id}/resync`),
                method: 'PUT',
                body: orderInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Orders'}, {type: 'OrdersSingle'}, { type: 'OrderTotals' }],
        }),
        getOrderWebshopJson: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/webshopjson`),
                method: 'GET'
            }),
            // Always ask the webshop again when the modal reopens
            keepUnusedDataFor: 0,
        }),
        getOrderShipments: builder.query({
            query: id => ({
                url: buildUrl(`/${id}/shipments`),
                method: 'GET'
            }),
            providesTags: () => [{ type: 'OrderShipments' }],
        }),
        getShipmentLabel: builder.query({
            query: id => ({
                url: buildUrl(`/shipmentlabel/${id}`),
                method: 'GET'
            }),
            providesTags: () => [{ type: 'ShipmentLabel' }],
        }),
        createShipmentLabel: builder.mutation({
            query: orderInfo => ({
                url: buildUrl(`/shipment/${orderInfo.id}/new`),
                method: 'POST',
                body: orderInfo
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrdersSingle' }, {type: 'Orders'}, { type: 'OrderLines' }, { type: `LogsOrder`, id: arg.id }],
        }),
        getShipmentLabelMutation: builder.mutation({
            query: id => ({
                url: buildUrl(`/shipmentlabel/${id}`),
                method: 'GET'
            }),
            providesTags: () => [{ type: 'ShipmentLabel' }],
        }),
        printShipmentLabel: builder.mutation({
            query: ({ shipmentId, workspaceId }) => ({
                url: `/shipments/${shipmentId}/print`,
                method: 'POST',
                body: { workspaceId },
            }),
        }),
        // Prints the labels of the given orders on the workspace label printer and returns one
        // result per order; orders whose labels all printed leave the labels to print view
        printOrderLabels: builder.mutation({
            query: ({ orderIds, workspaceId }) => ({
                url: `/shipments/print-order-labels`,
                method: 'POST',
                body: { orderIds, workspaceId },
            }),
            invalidatesTags: () => [{ type: 'Orders' }, { type: 'OrdersSingle' }, { type: 'OrderTotals' }],
        }),
        getDashboardOrderTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/dashboard/totals`),
                method: 'POST',
                body
            }),
        }),
        getRelationFullDashboard: builder.query({
            query: (body) => ({
                url: buildUrl(`/dashboard/relation/full`),
                method: 'POST',
                body
            }),
        }),
        getOrderTotals: builder.query({
            query: type => ({
                url: buildUrl(`/totals/${type}`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'OrderTotals' }],
        }),
        bulkUpdateOrders: builder.mutation({
            query: ({ orderIds, state, oldState = null, date_planned = null }) => ({
                url: buildUrl('/bulk-update'),
                method: 'PUT',
                body: {
                    orderIds,
                    state,
                    ...(oldState ? {oldState} : {}),
                    ...(date_planned ? {date_planned} : {})
                },
            }),
            invalidatesTags: (result, error, arg) => [{ type: "Orders" }, { type: 'OrderTotals' }, { type: "OrdersSingle" }],
        }),
        bulkCancelOrders: builder.mutation({
            query: cancelObj => ({
                url: buildUrl('/bulk-cancel'),
                method: 'PUT',
                body: cancelObj,
            }),
            invalidatesTags: (result, error, arg) => [{ type: "Orders" }, { type: "OrderTotals" },{ type: "OrdersSingle" },{ type: "OrderLines" },],
        }),
        bulkSplitBackorders: builder.mutation({
            query: splitObj => ({
                url: buildUrl('/bulk-split-backorder'),
                method: 'POST',
                body: splitObj,
            }),
            invalidatesTags: (result, error, arg) => [{ type: "Orders" }, { type: "OrderTotals" },{ type: "OrdersSingle" },{ type: "OrderLines" },{ type: 'OrderPickingLines' }],
        }),
        setOrderToShipped: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/settoshipped`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrdersSingle' }, {type: 'Orders' }, { type: 'OrderLines' }],
        }),
        creditOrderCosts: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/invoice/credit`),
                method: 'POST',
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrdersSingle' }],
        }),
        getOrderProductHistoryChart: builder.query({
            query: ({ productId, startDate, endDate, period }) => ({
                url: buildUrl(`/product/history/chart`),
                method: 'POST',
                body: { productId, startDate, endDate, period },
            }),
            providesTags: () => [{ type: 'OrderProductHistoryChart' }],
        }),
        getServicePoints: builder.query({
            query: reqBody => ({
                url: buildUrl(`/shipments/servicepoints`),
                method: 'POST',
                body: reqBody,
            }),
        }),
        exportOrders: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { success: true, message: jsonData.message, immediate: true };
                        }

                        // Background processing (status 202)
                        return { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { success: true, immediate: true };
                },
            }),
        }),
        exportOrderLines: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/orderlines/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { success: true, message: jsonData.message, immediate: true };
                        }

                        // Background processing (status 202)
                        return { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `orderlines_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { success: true, immediate: true };
                },
            }),
        }),
        exportShipments: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/shipments/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // Check if response is JSON (status 202 - processing or 200 with blobUrl)
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        // If immediate download is ready (status 200 with blobUrl)
                        if (jsonData.blobUrl) {
                            // For storage URLs or signed URLs, just trigger direct download
                            // No need to fetch again - the URL is already accessible
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank'; // Open in new tab as fallback
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { success: true, message: jsonData.message, immediate: true };
                        }

                        // Background processing (status 202)
                        return { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId };
                    }

                    // Legacy support: Direct blob response (for backwards compatibility)
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `shipments_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { success: true, immediate: true };
                },
            }),
        }),
    })
});

// console.log(apiSlice);
export const {
    useReplaceShipmentMutation,
    useGetRelationFullDashboardQuery,
    useGetDashboardOrderTotalsQuery,
    useGetOrdersQuery,
    useGetOrdersSelectQuery,
    useGetOrderQuery,
    useCreateOrderMutation,
    useDuplicateOrderMutation,
    useUpdateOrderMutation,
    useSetOrderToShippedMutation,
    useUpdatePriorityMutation,
    useGetOrderEventsQuery,
    useCreateOrderEventMutation,
    useUpdateOrderEventMutation,
    useDeleteOrderEventMutation,
    useUpdateOrderFieldsMutation,
    useUpdatePickupOrderMutation,
    useUpdateOrderPickingTypeMutation,
    useResyncOrderMutation,
    useGetOrderWebshopJsonQuery,
    useGetOrderStatusCountsQuery,
    useGetDashboardOrderStatusCountsQuery,
    useGetOrderCompareCountsDashboardQuery,
    useGetOrderLinesQuery,
    useGetAllOrderLinesQuery,
    useGetOrderColliQuery,
    useGetOrderMutationsQuery,
    useGetOrderPickingListQuery,
    useGetOrderPickingListPDFMutation,
    useGetOrderPickingSlipPDFMutation,
    useGetServicePointsQuery,
    useGetOrderPickingLinesQuery,
    useUpdateOrderPickingLineMutation,
    useSplitOrderMutation,
    useUpdateOrderLinesMutation,
    useGetOrderShipmentsQuery,
    useGetShipmentLabelQuery,
    useCreateShipmentLabelMutation,
    useGetOrderReplenishLinesQuery,
    useGetShipmentLabelMutationMutation,
    usePrintShipmentLabelMutation,
    usePrintOrderLabelsMutation,
    useCancelShipmentMutation,
    useActivateShipmentMutation,
    useGetOrderTotalsQuery,
    useEditOrderCarrierMutation,
    useBulkUpdateOrdersMutation,
    useBulkCancelOrdersMutation,
    useBulkSplitBackordersMutation,
    useGetPausedOrdersForProcessingQuery,
    useCreditOrderCostsMutation,
    useExportOrdersMutation,
    useExportOrderLinesMutation,
    useExportShipmentsMutation,
    useGetOrderProductHistoryChartQuery
} = ordersApiSlice;
